const isProduction = process.env.KEY_MODE === "production-keys";

export const getBaseUrl = () => {
	// Use environment variable if available, otherwise default to production URL
	return process.env.NEXT_PUBLIC_SITE_URL || "https://felixmobile.com.au";
};

export default isProduction;
